import { isPlatform } from '@ionic/react'
import {
  FuelTypeEnum,
  TransmissionEnum,
  RentalStatusEnum,
  RentalContractStatusEnum,
  RentalContractWorkScheduleEnum,
  DayEnum,
  DocumentsTypeEnum,
  TimezoneCode,
  InfoSourceEnum,
  TaxSystemEnum,
  RentalContractQuantityOfHoursEnum,
} from '~/shared/config/enums'
import { myPalette } from '~/shared/ui/theme'
export const AUTH_TOKEN_STORAGE_KEY = 'auth_token'
export const AUTH_PHONE_STORAGE_KEY = 'auth_phone'
export const SELECTED_PAY_CARD_BANK_CARD_ID = 'SELECTED_PAY_CARD_BANK_CARD_ID'
export const CURRENCY = '₽'
export const DEFAULT_REGION_OPTION = { id: '77', label: 'Москва' }

export const isMobileApp = isPlatform('capacitor') || isPlatform('cordova')
export const isIos = isMobileApp && isPlatform('ios')
export const isAndroid = isMobileApp && isPlatform('android')
export const SMS_CODE_LENGTH = 4
export const DADATA_FMS_UNIT_URL =
  'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fms_unit'
export const PERSONAL_DATA_AGREEMENT_URL =
  'https://prod-lkdriver-apark-pro.obs.ru-moscow-1.hc.sbercloud.ru/publicoffer/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5_%D0%BD%D0%B0_%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D1%83_%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85_%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85.pdf'

export type Option = { id: UniqueId; label: string; disabled?: boolean }
export type OptionEnum<T> = { id: T; label: string; disabled?: boolean }

export const carVehicleCategoriesOptions: Option[] = [
  { id: 'Эконом', label: 'Эконом' },
  { id: 'Комфорт', label: 'Комфорт' },
  { id: 'Комфорт +', label: 'Комфорт +' },
  { id: 'Бизнес', label: 'Бизнес' },
]

export const transmissionEnumLabels: Record<TransmissionEnum, string> = {
  [TransmissionEnum.AUTO]: 'Автомат',
  [TransmissionEnum.MANUAL]: 'Механика',
}

export const transmissionEnumOptions: Option[] = Object.keys(
  TransmissionEnum,
).map((value) => {
  const label = transmissionEnumLabels[value as keyof typeof TransmissionEnum]
  return {
    label,
    id: value,
  }
})

export const fuelTypeEnumLabels: Record<FuelTypeEnum, string> = {
  [FuelTypeEnum.AI92]: 'Бензин',
  [FuelTypeEnum.AI95]: 'Бензин',
  [FuelTypeEnum.AI98]: 'Бензин',
  [FuelTypeEnum.AI100]: 'Бензин',
  [FuelTypeEnum.DIESEL]: 'ДТ',
  [FuelTypeEnum.PROPANE]: 'Пропан',
  [FuelTypeEnum.METHANE]: 'Метан',
  [FuelTypeEnum.ELECTRICITY]: 'Электричество',
}

export const fuelTypeEnumOptions: Option[] = Object.keys(FuelTypeEnum).map(
  (value) => {
    const label = fuelTypeEnumLabels[value as keyof typeof FuelTypeEnum]
    return {
      label,
      id: value,
    }
  },
)

export const rentalContractWorkScheduleEnumOptions: OptionEnum<RentalContractWorkScheduleEnum>[] =
  Object.keys(RentalContractWorkScheduleEnum).map((value) => {
    const label =
      RentalContractWorkScheduleEnum[
        value as keyof typeof RentalContractWorkScheduleEnum
      ]
    return {
      label,
      id: label,
    }
  })

export const rentalContractQuantityOfHoursLabels: Record<
  RentalContractQuantityOfHoursEnum,
  string
> = {
  [RentalContractQuantityOfHoursEnum.ONE_WRITE_OFF]: 'Раз в день',
  [RentalContractQuantityOfHoursEnum.TWELVE_WRITE_OFF]: 'Раз в 2 часа',
  [RentalContractQuantityOfHoursEnum.TWO_WRITE_OFF]: 'Раз в 12 часов',
}

export const rentalContractQuantityOfHoursEnumOptions = [
  RentalContractQuantityOfHoursEnum.ONE_WRITE_OFF,
  RentalContractQuantityOfHoursEnum.TWO_WRITE_OFF,
  RentalContractQuantityOfHoursEnum.TWELVE_WRITE_OFF,
].map((value) => ({
  id: String(value),
  label: rentalContractQuantityOfHoursLabels[value],
}))

export const rentalStatusEnumLabels: Record<RentalStatusEnum, string> = {
  [RentalStatusEnum.IN_PROGRESS]: 'На рассмотрении',
  [RentalStatusEnum.APPROVED]: 'Одобрено',
}

export const rentalContractStatusEnumLabels: Record<
  RentalContractStatusEnum,
  string
> = {
  [RentalContractStatusEnum.SUSPENDED]: 'Приостановлен',
  [RentalContractStatusEnum.ACTIVE]: 'Активный',
  [RentalContractStatusEnum.SIGNING]: 'Ожидает подписания',
  [RentalContractStatusEnum.SIGNED]: 'Подписан',
  [RentalContractStatusEnum.CANCELLATION_IN_PROGRESS]: 'Отмена брони',
}

export const daysEnumLabels: Record<DayEnum, string> = {
  [DayEnum.Monday]: 'Понедельник',
  [DayEnum.Tuesday]: 'Вторник',
  [DayEnum.Wednesday]: 'Среда',
  [DayEnum.Thursday]: 'Четверг',
  [DayEnum.Friday]: 'Пятница',
  [DayEnum.Saturday]: 'Суббота',
  [DayEnum.Sunday]: 'Воскресенье',
}

export const daysEnumOptions: OptionEnum<DayEnum>[] = Object.keys(DayEnum).map(
  (value) => {
    const label = daysEnumLabels[value as keyof typeof DayEnum]
    return {
      label,
      id: value as DayEnum,
    }
  },
)

export const documentsCodeEnumLabels: Record<DocumentsTypeEnum, string> = {
  [DocumentsTypeEnum.OSAGO]: 'Осаго',
  [DocumentsTypeEnum.STS]: 'СТС',
  [DocumentsTypeEnum.DC]: 'Диагностическая карта',
  [DocumentsTypeEnum.LICENSE]: 'Лицензия',
}

export const countries = {
  RU: 'Россия',
  BY: 'Беларусь',
  KG: 'Киргизия',
  AU: 'Австралия',
  AT: 'Австрия',
  AZ: 'Азербайджан',
  AX: 'Аландские острова',
  AL: 'Албания',
  DZ: 'Алжир',
  AS: 'Американское Самоа',
  AI: 'Ангилья',
  AO: 'Ангола',
  AD: 'Андорра',
  AQ: 'Антарктида',
  AG: 'Антигуа и Барбуда',
  AR: 'Аргентина',
  AM: 'Армения',
  AW: 'Аруба',
  AF: 'Афганистан',
  BS: 'Багамы',
  BD: 'Бангладеш',
  BB: 'Барбадос',
  BH: 'Бахрейн',
  BZ: 'Белиз',
  BE: 'Бельгия',
  BJ: 'Бенин',
  BM: 'Бермуды',
  BG: 'Болгария',
  BO: 'Боливия',
  BQ: 'Бонэйр, Синт-Эстатиус и Саба',
  BA: 'Босния и Герцеговина',
  BW: 'Ботсвана',
  BR: 'Бразилия',
  IO: 'Британская территория в Индийском океане',
  BN: 'Бруней',
  BF: 'Буркина-Фасо',
  BI: 'Бурунди',
  BT: 'Бутан',
  VU: 'Вануату',
  VA: 'Ватикан',
  GB: 'Великобритания',
  HU: 'Венгрия',
  VE: 'Венесуэла',
  VG: 'Виргинские Острова (Великобритания)',
  VI: 'Виргинские Острова (США)',
  UM: 'Внешние малые острова (США)',
  TL: 'Восточный Тимор',
  VN: 'Вьетнам',
  GA: 'Габон',
  HT: 'Гаити',
  GY: 'Гайана',
  GM: 'Гамбия',
  GH: 'Гана',
  GP: 'Гваделупа',
  GT: 'Гватемала',
  GF: 'Гвиана',
  GN: 'Гвинея',
  GW: 'Гвинея-Бисау',
  DE: 'Германия',
  GG: 'Гернси',
  GI: 'Гибралтар',
  HN: 'Гондурас',
  HK: 'Гонконг',
  PS: 'Государство Палестина',
  GD: 'Гренада',
  GL: 'Гренландия',
  GR: 'Греция',
  GE: 'Грузия',
  GU: 'Гуам',
  DK: 'Дания',
  CD: 'Демократическая Республика Конго',
  JE: 'Джерси',
  DJ: 'Джибути',
  DM: 'Доминика',
  DO: 'Доминиканская Республика',
  EG: 'Египет',
  ZM: 'Замбия',
  ZW: 'Зимбабве',
  IL: 'Израиль',
  IN: 'Индия',
  ID: 'Индонезия',
  JO: 'Иордания',
  IQ: 'Ирак',
  IR: 'Иран',
  IE: 'Ирландия',
  IS: 'Исландия',
  ES: 'Испания',
  IT: 'Италия',
  YE: 'Йемен',
  KP: 'КНДР (Корейская Народно-Демократическая Республика)',
  CN: 'КНР (Китайская Народная Республика)',
  CV: 'Кабо-Верде',
  KZ: 'Казахстан',
  KH: 'Камбоджа',
  CM: 'Камерун',
  CA: 'Канада',
  QA: 'Катар',
  KE: 'Кения',
  CY: 'Кипр',
  KI: 'Кирибати',
  CC: 'Кокосовые острова',
  CO: 'Колумбия',
  KM: 'Коморы',
  XK: 'Косово',
  CR: 'Коста-Рика',
  CI: 'Кот-д’Ивуар',
  CU: 'Куба',
  KW: 'Кувейт',
  CW: 'Кюрасао',
  LA: 'Лаос',
  LV: 'Латвия',
  LS: 'Лесото',
  LR: 'Либерия',
  LB: 'Ливан',
  LY: 'Ливия',
  LT: 'Литва',
  LI: 'Лихтенштейн',
  LU: 'Люксембург',
  MU: 'Маврикий',
  MR: 'Мавритания',
  MG: 'Мадагаскар',
  YT: 'Майотта',
  MO: 'Макао',
  MW: 'Малави',
  MY: 'Малайзия',
  ML: 'Мали',
  MV: 'Мальдивы',
  MT: 'Мальта',
  MA: 'Марокко',
  MQ: 'Мартиника',
  MH: 'Маршалловы Острова',
  MX: 'Мексика',
  FM: 'Микронезия',
  MZ: 'Мозамбик',
  MD: 'Молдавия',
  MC: 'Монако',
  MN: 'Монголия',
  MS: 'Монтсеррат',
  MM: 'Мьянма',
  NA: 'Намибия',
  NR: 'Науру',
  NP: 'Непал',
  NE: 'Нигер',
  NG: 'Нигерия',
  NL: 'Нидерланды',
  NI: 'Никарагуа',
  NU: 'Ниуэ',
  NZ: 'Новая Зеландия',
  NC: 'Новая Каледония',
  NO: 'Норвегия',
  AE: 'ОАЭ',
  OM: 'Оман',
  BV: 'Остров Буве',
  IM: 'Остров Мэн',
  NF: 'Остров Норфолк',
  CX: 'Остров Рождества',
  KY: 'Острова Кайман',
  CK: 'Острова Кука',
  PN: 'Острова Питкэрн',
  SH: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
  PK: 'Пакистан',
  PW: 'Палау',
  PA: 'Панама',
  PG: 'Папуа — Новая Гвинея',
  PY: 'Парагвай',
  PE: 'Перу',
  PL: 'Польша',
  PT: 'Португалия',
  PR: 'Пуэрто-Рико',
  CG: 'Республика Конго',
  KR: 'Республика Корея',
  RE: 'Реюньон',
  RW: 'Руанда',
  RO: 'Румыния',
  EH: 'САДР',
  US: 'США',
  SV: 'Сальвадор',
  WS: 'Самоа',
  SM: 'Сан-Марино',
  ST: 'Сан-Томе и Принсипи',
  SA: 'Саудовская Аравия',
  SZ: 'Свазиленд',
  MK: 'Северная Македония',
  MP: 'Северные Марианские Острова',
  SC: 'Сейшельские Острова',
  BL: 'Сен-Бартелеми',
  MF: 'Сен-Мартен',
  PM: 'Сен-Пьер и Микелон',
  SN: 'Сенегал',
  VC: 'Сент-Винсент и Гренадины',
  KN: 'Сент-Китс и Невис',
  LC: 'Сент-Люсия',
  RS: 'Сербия',
  SG: 'Сингапур',
  SX: 'Синт-Мартен',
  SY: 'Сирия',
  SK: 'Словакия',
  SI: 'Словения',
  SB: 'Соломоновы Острова',
  SO: 'Сомали',
  SD: 'Судан',
  SR: 'Суринам',
  SL: 'Сьерра-Леоне',
  TJ: 'Таджикистан',
  TH: 'Таиланд',
  TW: 'Тайвань',
  TZ: 'Танзания',
  TC: 'Теркс и Кайкос',
  TG: 'Того',
  TK: 'Токелау',
  TO: 'Тонга',
  TT: 'Тринидад и Тобаго',
  TV: 'Тувалу',
  TN: 'Тунис',
  TM: 'Туркмения',
  TR: 'Турция',
  UG: 'Уганда',
  UZ: 'Узбекистан',
  UA: 'Украина',
  WF: 'Уоллис и Футуна',
  UY: 'Уругвай',
  FO: 'Фареры',
  FJ: 'Фиджи',
  PH: 'Филиппины',
  FI: 'Финляндия',
  FK: 'Фолклендские острова',
  FR: 'Франция',
  PF: 'Французская Полинезия',
  TF: 'Французские Южные и Антарктические Территории',
  HM: 'Херд и Макдональд',
  HR: 'Хорватия',
  CF: 'ЦАР',
  TD: 'Чад',
  ME: 'Черногория',
  CZ: 'Чехия',
  CL: 'Чили',
  CH: 'Швейцария',
  SE: 'Швеция',
  SJ: 'Шпицберген и Ян-Майен',
  LK: 'Шри-Ланка',
  EC: 'Эквадор',
  GQ: 'Экваториальная Гвинея',
  ER: 'Эритрея',
  EE: 'Эстония',
  ET: 'Эфиопия',
  ZA: 'ЮАР',
  GS: 'Южная Георгия и Южные Сандвичевы Острова',
  SS: 'Южный Судан',
  JM: 'Ямайка',
  JP: 'Япония',
}

export const countriesOptions = Object.values(countries).map((value) => ({
  id: value,
  label: value,
}))

export const STATUS_VARIANT: Record<
  string,
  { backgroundColor: string; color: string; border?: string }
> = {
  green: {
    backgroundColor: myPalette.green['100'],
    color: myPalette.green['600'],
  },
  outlinedGreen: {
    backgroundColor: 'transparent',
    color: myPalette.green['600'],
    border: `1px solid ${myPalette.green['100']}`,
  },
  red: {
    backgroundColor: myPalette.red['100'],
    color: myPalette.red['600'],
  },
  outlinedRed: {
    backgroundColor: 'transparent',
    color: myPalette.red['600'],
    border: `1px solid ${myPalette.red['600']}`,
  },
  gray: {
    backgroundColor: myPalette.dark['100'],
    color: myPalette.dark['700'],
  },
  yellow: {
    backgroundColor: myPalette.yellow['100'],
    color: myPalette.yellow['600'],
  },
  brand: {
    backgroundColor: myPalette.brand['100'],
    color: myPalette.brand['700'],
  },
  blue: {
    backgroundColor: myPalette.blue['100'],
    color: myPalette.blue['600'],
  },
  purple: {
    backgroundColor: myPalette.purple['100'],
    color: myPalette.purple['600'],
  },
}

export const timezoneCodeLabels: Record<TimezoneCode, string> = {
  [TimezoneCode.KALININGRAD]: 'Калининград (UTC+2)',
  [TimezoneCode.MOSCOW]: 'Москва (UTC+3)',
  [TimezoneCode.SAMARA]: 'Самара (UTC+4)',
  [TimezoneCode.YEKATERINBURG]: 'Екатеринбург (UTC+5)',
  [TimezoneCode.OMSK]: 'Омск (UTC+6)',
  [TimezoneCode.KRASNOYARSK]: 'Красноярск (UTC+7)',
  [TimezoneCode.IRKUTSK]: 'Иркутск (UTC+8)',
  [TimezoneCode.YAKUTSK]: 'Якутск (UTC+9)',
  [TimezoneCode.VLADIVOSTOK]: 'Владивосток (UTC+10)',
  [TimezoneCode.MAGADAN]: 'Магадан (UTC+11)',
  [TimezoneCode.KAMCHATKA]: 'Камчатка (UTC+12)',
}

export const timezoneCodeOptions: OptionEnum<TimezoneCode>[] = Object.values(
  TimezoneCode,
).map((value) => ({
  label: timezoneCodeLabels[value as TimezoneCode],
  id: value as TimezoneCode,
}))

export const InfoSourceEnumLabels: Record<InfoSourceEnum, string> = {
  [InfoSourceEnum.AVITO]: 'Авито',
  [InfoSourceEnum.BROWSER_ADVERTISEMENT]:
    'Реклама на странице браузера Яндекс/Гугл',
  [InfoSourceEnum.CAR_ADVERTISEMENT]: 'Реклама на авто',
  [InfoSourceEnum.LEAFLET]: 'Листовка',
  [InfoSourceEnum.PASSED_BY]: 'Проходил мимо (увидел вывеску парка)',
  [InfoSourceEnum.PREVIOUS_WORK]: 'Ранее работал с парком',
  [InfoSourceEnum.RECOMMENDATION]: 'Рекомендация',
  [InfoSourceEnum.SITE]: 'Сайт',
  [InfoSourceEnum.TELEGRAM]: 'Telegram',
  [InfoSourceEnum.YANDEX_GARAGE]: 'Яндекс Гараж',
  [InfoSourceEnum.YANDEX_MAPS]: 'Яндекс Карты',
}

export const infoSourceOptions: OptionEnum<InfoSourceEnum>[] = Object.values(
  InfoSourceEnum,
)
  .map((value) => ({
    label: InfoSourceEnumLabels[value as InfoSourceEnum],
    id: value as InfoSourceEnum,
  }))
  .sort((a, b) => a.label.localeCompare(b.label))

export const taxSystemEnumLabels: Record<TaxSystemEnum, string> = {
  [TaxSystemEnum.OSN]: 'Общая система налогообложения (ОСН/ОСНО)',
  [TaxSystemEnum.USN]: 'Упрощенная система налогообложения (УСН)',
  [TaxSystemEnum.AUSN]:
    'Автоматизированная упрощенная система налогообложения (АУСН)',
  [TaxSystemEnum.OSNP]: 'Патентная система налогообложения (ОСН)',
  [TaxSystemEnum.USNP]: 'Патентная система налогообложения (УСН)',
}

export const taxSystemEnumOptions: OptionEnum<TaxSystemEnum>[] = Object.values(
  TaxSystemEnum,
).map((value) => ({
  label: taxSystemEnumLabels[value as TaxSystemEnum],
  id: value as TaxSystemEnum,
}))
